const options = [
    {
        content: "p",
        icon: false,
        text: "Pequeno",
        desc: "p",
        price: 6,
    },
    {
        content: "m",
        icon: false,
        text: "Médio",
        desc: "m",
        price: 8,
    },
    {
        content: "g",
        icon: false,
        text: "Grande",
        desc: "g",
        price: 10,
    },
];

export default options;
